import { Line, mixins } from 'vue-chartjs'
import 'chartjs-plugin-annotation'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {options: {}},
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/LineChart2.js